import { createSlice } from "@reduxjs/toolkit";

import { getAPI } from "../../api/nodeRedApi/axiosApi";
import { getLastData, getForecast } from "../../api/ipma/ipmaApi";

import { getSystemStatus } from "../../api/nodeRedApi/system";
import { getSensorLastReadings as getSensorLastReadingsAPI } from "../../api/nodeRedApi/project";

import { sleep } from "../../common/utils/utils";

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loader: null,
    error: null,
    history: [],
    status: null,
    lastReadings: [],
    meteoData: null,
  },
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
    },

    setStatus: (state, action) => {
      state.status = { ...action.payload, timestamp: new Date().getTime() };
      //state.history = [...state.history, action.payload];
    },

    setLastReadings: (state, action) => {
      state.lastReadings = action.payload;
    },

    setMeteoData: (state, action) => {
      state.meteoData = action.payload;
    },
  },
});

export const { setLoader, setError, setStatus, setLastReadings, setMeteoData } = dashboardSlice.actions;

export const getStatus = (project) => async (dispatch) => {
  console.log("GET");
  dispatch(setLoader("LOADING"));
  let status;
  let api = getAPI(project?.id);
  if (api) {
    let result = await getSystemStatus(api);
    status = result.data;
    console.log("status", status);
  } else {
    status = {
      cpu: 45,
      memory: 83,
      disk: 55,
      uptime: 3600,
      temperature: 44.5,
    };
    await sleep(1000);
  }
  dispatch(setStatus(status));
  dispatch(setLoader(null));
};

export const getSensorLastReadings = (project, codes) => async (dispatch) => {
  console.log("getSensorLastReadings");
  dispatch(setLoader("LOADING"));
  let result = [];
  let api = getAPI(project?.id);
  if (api) {
    result = await getSensorLastReadingsAPI(api, codes);
  } else {
    await sleep(1000);
  }
  console.log("getSensorLastReadings result: %o", result.data);
  dispatch(setLastReadings(result.data));
  dispatch(setLoader(null));
};

export const getMeteoData = () => async (dispatch) => {
  dispatch(setLoader("LOADING"));
  let result = await getLastData();
  let forecast = await getForecast();
  // console.log("getMeteoData result: %o", result);
  // console.log("getMeteoData forecast: %o", forecast);
  dispatch(setMeteoData({ ...result, forecast: forecast?.data?.data }));
  dispatch(setLoader(null));
};

export const selectStatus = (state) => state.dashboard.status;
export const selectSelectedProject = (state) => state.authentication.selectedProject;
export const selectLastReadings = (state) => state.dashboard.lastReadings;
export const selectMeteoData = (state) => state.dashboard.meteoData;

export default dashboardSlice.reducer;
